var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.56 0.5H15.56V15.5H16.56V0.5Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 0H15.06V16H17.06V0Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.11 4.00004L11.81 3.29004L16.06 7.54004L20.3 3.29004L21.01 4.00004L16.06 8.95004L11.11 4.00004Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 4.00009L16.76 7.54009L20.3 4.00009ZM11.81 4.00009L15.35 7.54009L11.81 4.00009ZM20.3 2.59009L16.06 6.83009L11.81 2.59009L10.4 4.00009L16.06 9.66009L21.7 4.00009L20.3 2.59009Z",
    fill: "currentcolor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.56 16.5H15.56V31.5H16.56V16.5Z",
    fill: "currentcolor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 16H15.06V32H17.06V16Z",
    fill: "currentcolor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.06 24.46L11.81 28.71L11.11 28L16.06 23.05L21.01 28L20.3 28.71L16.06 24.46Z",
    fill: "currentcolor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.76 24.4601L20.3 28.0001L16.76 24.4601ZM15.35 24.4601L11.81 28.0001L15.35 24.4601ZM16.06 22.3401L10.4 28.0001L11.81 29.4101L16.06 25.1701L20.3 29.4101L21.7 28.0001L16.05 22.3401H16.06Z",
    fill: "currentcolor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8813 7.81113L2.38145 8.67725L15.3731 16.175L15.873 15.3089L2.8813 7.81113Z",
    fill: "currentcolor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07 8.49988L15.19 15.4999L3.07 8.49988ZM2.7 7.12988L1.7 8.86988L15.56 16.8699L16.56 15.1299L2.7 7.12988Z",
    fill: "currentcolor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93 13.32L8.73 11.77L7.17 5.96996L8.14 5.70996L9.95 12.47L3.19 14.29L2.93 13.32Z",
    fill: "currentcolor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79 6.3301L9.34 12.1201L9.08 11.1201L7.79 6.3301ZM7.48 12.6201L3.54 13.6701L7.48 12.6201ZM8.48 5.1001L6.55 5.6201L8.1 11.4101L2.32 13.0001L2.84 14.9301L10.56 12.8601L8.49 5.1001H8.48Z",
    fill: "currentcolor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7331 15.8241L16.2333 16.6902L29.225 24.1879L29.7248 23.3218L16.7331 15.8241Z",
    fill: "currentcolor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.92 16.4999L29.05 23.4999L16.92 16.4999ZM16.56 15.1299L15.56 16.8699L29.41 24.8699L30.41 23.1299L16.56 15.1299Z",
    fill: "currentcolor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.16 19.52L28.92 17.71L29.18 18.68L23.39 20.23L24.94 26.03L23.97 26.29L22.16 19.52Z",
    fill: "currentcolor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.57 18.3301L24.64 19.3801L28.57 18.3301ZM22.77 19.8801L23.03 20.8801L24.33 25.7101L22.77 19.9201V19.8801ZM29.28 17.1401L21.55 19.2101L23.62 26.9401L25.55 26.4201L24 20.5901L29.79 19.0001L29.28 17.0701V17.1401Z",
    fill: "currentcolor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3798 15.8125L2.38937 23.3125L2.88937 24.1785L15.8798 16.6785L15.3798 15.8125Z",
    fill: "currentcolor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.56 15.1299L1.7 23.1299L2.7 24.8699L16.56 16.8699L15.56 15.1299Z",
    fill: "currentcolor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17 26.03L8.73 20.23L2.93 18.68L3.19 17.71L9.95 19.52L8.14 26.29L7.17 26.03Z",
    fill: "currentcolor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54 18.3301L7.48 19.3801L3.54 18.3301ZM9.34 19.8801L7.79 25.6701L9.08 20.8401L9.34 19.8401V19.8801ZM2.84 17.1001L2.32 19.0001L8.11 20.5601L6.56 26.3801L8.49 26.9001L10.56 19.1701L2.84 17.1001Z",
    fill: "currentcolor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2242 7.81934L16.2338 15.3193L16.7338 16.1854L29.7242 8.68536L29.2242 7.81934Z",
    fill: "currentcolor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.41 7.12988L15.56 15.1299L16.56 16.8699L30.41 8.86988L29.41 7.12988Z",
    fill: "currentcolor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.16 12.47L23.97 5.70996L24.94 5.96996L23.39 11.77L29.18 13.32L28.92 14.29L22.16 12.47Z",
    fill: "currentcolor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.33 6.3301L23.03 11.1601L22.77 12.1601L24.33 6.3701V6.3301ZM24.64 12.6601L28.57 13.7101L24.64 12.6601ZM23.64 5.1401L21.57 12.8701L29.3 14.9401L29.79 13.0001L24 11.4101L25.55 5.6201L23.62 5.1001L23.64 5.1401Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.2f0acc012be5d0c67186cc3ad9eae0e3.svg";
export { ForwardRef as ReactComponent };